var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/UrlParameters/UrlParameters", "hypo_elements/Typescripts/UuidService/UuidService", "hypo_elements/Typescripts/GoogleAnalyticsTrackingService/GoogleAnalyticsTrackingService", "hypo_elements/Typescripts/SendEvent/CheckSendEvent", "jquery"], function (require, exports, UrlParameters, UuidService, GoogleAnalyticsTrackingService, CheckSendEvent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    UrlParameters = __importStar(UrlParameters);
    UuidService = __importStar(UuidService);
    GoogleAnalyticsTrackingService = __importStar(GoogleAnalyticsTrackingService);
    CheckSendEvent = __importStar(CheckSendEvent);
    $(function () {
        var uuidPromise = UuidService.getUuid();
        var $kontaktaufnahme = $(".kontaktaufnahme");
        var $kontaktaufnahmeForm = $kontaktaufnahme.find(".kontaktaufnahme_form");
        var $confirmationDialog = $kontaktaufnahme.find(".kontaktaufnahme_confirmationDialog");
        var $errorDialog = $kontaktaufnahme.find(".kontaktaufnahme_errorDialog");
        var url = "/rest-api/anfragen/kontaktaufnahme";
        var formNameForTracking = "kontaktaufnahme";
        if (CheckSendEvent.sentEvent("kontaktaufnahme")) {
            uuidPromise.done(function (uuid) {
                GoogleAnalyticsTrackingService.submitCheckoutTracking(uuid, formNameForTracking);
            });
        }
        var betreff = UrlParameters.getParameterByName("betreff");
        if (betreff !== undefined) {
            $kontaktaufnahme.find("select[name='betreff']").val(betreff);
        }
        var emailId = "email_34279";
        var telefonId = "telefon_34279";
        var rueckrufdatumId = "#rueckrufdatum_34279";
        var rueckrufuhrzeitId = "#rueckrufuhrzeit_34279";
        $("input[name='kontaktaufnahme']").on("click", function () {
            var value = $("input[name='kontaktaufnahme']:checked").val();
            if (value === "email") {
                showElements([emailId]);
                hideElements([telefonId, rueckrufdatumId, rueckrufuhrzeitId]);
            }
            if (value === "telefon") {
                hideElements([emailId]);
                showElements([telefonId, rueckrufdatumId, rueckrufuhrzeitId]);
            }
        });
        function hideElements(elementIds) {
            elementIds.forEach(function (selector) {
                var $container = $(selector).closest(".formElement");
                $container.addClass("formElement-hidden");
                $container.find("input, select").attr("disabled", "disabled");
            });
        }
        function showElements(elementIds) {
            elementIds.forEach(function (selector) {
                var $container = $(selector).closest(".formElement");
                $container.removeClass("formElement-hidden");
                $container.find("input, select").removeAttr("disabled");
            });
        }
        $kontaktaufnahmeForm.each(function (index, element) {
            var $form = $(element);
            $form.submit(function (event) {
                uuidPromise
                    .done(function (uuid) {
                    submitForm($form, uuid);
                })
                    .fail(function () {
                    handleFailedSubmit();
                    uuidPromise = UuidService.getUuid();
                })
                    .always(function () {
                    event.preventDefault();
                });
            });
            var submitForm = function ($form, uuid) {
                $form.find("input[name=uuid]").val(uuid);
                var betreff = $form.find("select[name='betreff']").val();
                var alleFelder = $form.find(":input").serialize();
                $.post(url, alleFelder)
                    .done(function () {
                    handleSuccessfulSubmit(betreff);
                })
                    .fail(handleFailedSubmit);
            };
            var handleSuccessfulSubmit = function (productSpecification) {
                uuidPromise.done(function (uuid) {
                    GoogleAnalyticsTrackingService.submitPurchaseTracking(uuid, formNameForTracking + "-" + productSpecification);
                });
                $errorDialog.hide();
                $form.hide();
                $confirmationDialog.show();
                $form.trigger("reset");
            };
            var handleFailedSubmit = function () {
                $confirmationDialog.hide();
                $errorDialog.show();
            };
        });
    });
});
